import styles from './UserAvatar.module.css';

interface UserAvatarProps {
    src: string | null;
    name: string;
    size?: 'sm' | 'md' | 'lg';
}

function getInitials(name: string): string {
    return name
        .split(' ')
        .map((word) => word.charAt(0))
        .slice(0, 2)
        .join('')
        .toUpperCase();
}

export function UserAvatar({ src, name, size = 'md' }: UserAvatarProps) {
    const initials = getInitials(name || '?');

    if (src) {
        return (
            <img
                className={`${styles.avatar} ${styles[size]}`}
                src={src}
                alt={`Avatar de ${name}`}
                referrerPolicy="no-referrer"
            />
        );
    }

    return (
        <div className={`${styles.avatar} ${styles.fallback} ${styles[size]}`}>
            <span>{initials}</span>
        </div>
    );
}
